'use client';

import { SvgRefresh } from '@common/icon';

interface FilterSidebarShellProps {
  onReset: () => void;
  children: React.ReactNode;
}

export function FilterSidebarShell({
  onReset,
  children,
}: FilterSidebarShellProps) {
  return (
    <aside className="block w-202 shrink-0 self-stretch px-24 mobile-tablet:hidden">
      <div className="flex flex-col gap-12">
        <div className="flex items-center justify-between px-12 pb-12">
          <h2 className="font-700 text-Gray-900 typo-body3">필터</h2>
          <button
            type="button"
            className="flex h-40 items-center justify-center gap-4 py-8"
            onClick={onReset}
          >
            <SvgRefresh className="size-14 text-Gray-black" />
            <span className="font-700 tracking-[-0.28px] text-Gray-600 typo-body4">
              초기화
            </span>
          </button>
        </div>
        {children}
      </div>
    </aside>
  );
}
